import React from 'react';
import { shape, string } from 'prop-types';

import StyledLabel from './wrapped-styled-label';
import { getFontClassName, namespace } from '../common';

export const ContentDetails = ({ content }) => {
  const { label, title, subtitle } = content || {};
  const updateLabel = ({ text, styles } = {}) => ({
    text: '{tienda} {verify}',
    values: [
      {
        key: 'verify',
        icon_id: 'cockade',
        type: 'icon',
      },
      {
        key: 'tienda',
        type: 'text',
        text,
        className: getFontClassName(styles),
      },
    ],
  });

  return (
    <>
      {label?.text && (
        <div className={`${namespace}__content-label-container`}>
          <StyledLabel as="span" className={`${namespace}__content-label`} {...updateLabel(label)} />
        </div>
      )}
      {title?.text && <StyledLabel as="span" className={`${namespace}__content-title`} {...title} />}
      {subtitle?.text && <StyledLabel as="p" className={`${namespace}__content-subtitle`} {...subtitle} />}
    </>
  );
};

ContentDetails.propTypes = {
  content: shape({
    label: shape({
      text: string,
    }),
    title: shape({
      text: string,
    }),
    subtitle: shape({
      text: string,
    }),
  }),
};
